/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  QuoteResponse
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Get Instrument Quote
 */
export const getInstrumentQuote = (
    conid: number,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<QuoteResponse>(
      {url: `/portfolio/instruments/${conid}/quote`, method: 'GET', signal
    },
      options);
    }




export const getGetInstrumentQuoteQueryKey = (conid: number,) => {
    return [
    `/portfolio/instruments/${conid}/quote`
    ] as const;
    }


export const getGetInstrumentQuoteQueryOptions = <TData = Awaited<ReturnType<typeof getInstrumentQuote>>, TError = HTTPValidationError>(conid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInstrumentQuote>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetInstrumentQuoteQueryKey(conid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getInstrumentQuote>>> = ({ signal }) => getInstrumentQuote(conid, requestOptions, signal);





   return  { queryKey, queryFn, enabled: conid !== null && conid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getInstrumentQuote>>, TError, TData> & { queryKey: QueryKey }
}

export type GetInstrumentQuoteQueryResult = NonNullable<Awaited<ReturnType<typeof getInstrumentQuote>>>
export type GetInstrumentQuoteQueryError = HTTPValidationError


/**
 * @summary Get Instrument Quote
 */

export function useGetInstrumentQuote<TData = Awaited<ReturnType<typeof getInstrumentQuote>>, TError = HTTPValidationError>(
 conid: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getInstrumentQuote>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetInstrumentQuoteQueryOptions(conid,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






